import React, { useState } from "react";
import { DialogTrigger, DialogTriggerProps } from "react-aria-components";

interface TriggerOptions {
  toggle: () => void;
}

interface RenderOptions {
  close: () => void;
}

export const ModalTriggerContext = React.createContext<TriggerOptions>({
  toggle: () => {
    console.warn("Modal toggle attempted, but modal was not in a ModalTrigger");
  },
});

export interface ModalTriggerProps
  extends Omit<DialogTriggerProps, "children"> {
  trigger?: React.ReactNode | ((options: TriggerOptions) => React.ReactNode);
  children?: React.ReactNode | ((options: RenderOptions) => React.ReactNode);
}

export function ModalTriggerRAC(props: ModalTriggerProps) {
  const { trigger, children, ...dialogTriggerProps } = props;

  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen((curr) => !curr);

  const close = () => setIsOpen(false);

  return (
    <ModalTriggerContext.Provider value={{ toggle }}>
      <DialogTrigger
        isOpen={isOpen}
        onOpenChange={setIsOpen}
        {...dialogTriggerProps}
      >
        {typeof trigger === "function" ? trigger({ toggle }) : trigger}
        {typeof children === "function" ? children({ close }) : children}
      </DialogTrigger>
    </ModalTriggerContext.Provider>
  );
}
